/** Human unit roster — plate, mail, tabards and one broad-winged dragon. */
export const ART_UNITS_HUMAN: string[][][] = [
  /* 0 Knight — closed great-helm, kite shield, straight arming sword, tabard over mail */
  [
    [
      '            m   ',
      '      pp    md  ',
      '     ddddd  md  ',
      '    dmmmmmd md  ',
      '    dmkkkmd md  ',
      '     dmmmd  md  ',
      '   ddmPPPmddmd  ',
      ' dPPdmPPPPmdmd  ',
      ' dyPdmPPPPmdmd  ',
      ' dPPdmPPPPmyyyy ',
      ' dPPdmppppdsb   ',
      '  dPdmddddmd    ',
      '   d dm  md     ',
      '     dm  md     ',
      '     dm  md     ',
      '    ###  ###    ',
    ],
    [
      '                ',
      '     pp         ',
      '     ddddd      ',
      '    dmmmmmd   m ',
      '    dmkkkmd  md ',
      '     dmmmd  md  ',
      '   ddmPPPmddm   ',
      ' dPPdmPPPPmyyy  ',
      ' dyPdmPPPPmsb   ',
      ' dPPdmPPPPdd    ',
      '  dPdmppppmd    ',
      '   d dddddd     ',
      '    dm   md     ',
      '   dm     md    ',
      '  dm       md   ',
      ' ###       ###  ',
    ],
  ],
  /* 1 Archer — open leather cap, quiver at the shoulder, tall stave bow; frame 1 draws it */
  [
    [
      '             md ',
      '   w         ww ',
      '  wd         ww ',
      '  wd   qqqq  q  ',
      ' w d   skks qq  ',
      ' w d   qssq qq  ',
      ' w d  qPPPPqq   ',
      ' wsdsssPPPPq    ',
      ' w d   PPPPq    ',
      ' w d   qyyq     ',
      ' w d   pppp     ',
      '  wd   pppp     ',
      '  wd   qq qq    ',
      '   w   qq qq    ',
      '       qq qq    ',
      '      ### ###   ',
    ],
    [
      '             md ',
      '   w         ww ',
      '  wd         ww ',
      '  w d  qqqq  q  ',
      ' w   d skks qq  ',
      ' w    dqssq qq  ',
      'mwwwwwsPPPPqq   ',
      ' w    dPPPPq    ',
      ' w   d PPPPq    ',
      ' w  d  qyyq     ',
      ' w d   pppp     ',
      '  wd   pppp     ',
      '  wd  qq   qq   ',
      '   w qq    qq   ',
      '    qq      qq  ',
      '   ###      ### ',
    ],
  ],
  /* 2 Wizard — pointed hat with a coloured band, white beard, crystal-topped staff */
  [
    [
      '        v   c   ',
      '       vv  cvc  ',
      '      vvvv ccc  ',
      '     vvvvvv w   ',
      '    ppppppppw   ',
      '     sksks  w   ',
      '     NNNNN  w   ',
      '    PPNNNPPsw   ',
      '    PPPNPPP w   ',
      '    PPyyyPP w   ',
      '    PPPPPPP w   ',
      '   pPPPPPPPpw   ',
      '   pPPPPPPPpw   ',
      '   ppPPPPPppw   ',
      '  ppppppppppw   ',
      '  ##########w   ',
    ],
    [
      '        v   v   ',
      '       vv  vcv  ',
      '      vvvv vvv  ',
      '     vvvvvv w   ',
      '    ppppppppw   ',
      '     sksks  w   ',
      '  c  NNNNN  w   ',
      '   sPPNNNPPsw   ',
      '    PPPNPPP w   ',
      '    PPyyyPP w   ',
      '    PPPPPPP w   ',
      '  pPPPPPPPPpw   ',
      '  ppPPPPPPppw   ',
      ' pppPPPPPpppw   ',
      ' pppppppppppw   ',
      ' ###########w   ',
    ],
  ],
  /* 3 Thief — deep hood, short cloak, gold-guarded dagger; frame 1 is a lunge */
  [
    [
      '                ',
      '       oo       ',
      '     oooooo     ',
      '     oskkso     ',
      '     oossoo     ',
      '     oooooo     ',
      '   ooPPPPPoo    ',
      '   oqPPPPPqo    ',
      '   oqPPPPPqsymm ',
      '   oqpyypqo     ',
      '   oppppppo     ',
      '   ooppppoo     ',
      '   ooqq  qq     ',
      '    oqq  qq     ',
      '     qq  qq     ',
      '    ###  ###    ',
    ],
    [
      '                ',
      '      oo        ',
      '    oooooo      ',
      '    oskkso      ',
      '    oossoo      ',
      '    ooooooo     ',
      '  ooPPPPPooo    ',
      '  oqPPPPPqosymm ',
      '  oqpyypqoo     ',
      ' ooppppppoo     ',
      ' oooppppoo      ',
      ' ooooqq qq      ',
      ' oo qq   qq     ',
      '   qq     qq    ',
      '  qq       qq   ',
      ' ###       ###  ',
    ],
  ],
  /* 4 Dragon — horned skull, 30px wingspan, clawed legs, spade tail.
     Two frames: wings held out flat on the glide, then swept down and drawn
     in on the beat, with the tail lashing the other way and the nostrils lit. */
  [
    [
      '              #PP#              ',
      '              #pp#              ',
      '            d#PPPP#d            ',
      '            d#yPPy#d            ',
      '             #PPPP#             ',
      '       #####  #PP#  #####       ',
      '    ###ppppp #PPPP# ppppp###    ',
      '  ##ppPppPpp#PPPPPP#ppPppPpp##  ',
      ' #ppPppPppPp#PPPPPP#pPppPppPpp# ',
      '  #ppPppPppp#PPPPPP#pppPppPpp#  ',
      '   #ppPppppp #PPPP# pppppPpp#   ',
      '     ##ppppp #PPPP# ppppp##     ',
      '       ##ppp #PPPP# ppp##       ',
      '         ##p #PPPP# p##         ',
      '            dpPPPPpd            ',
      '            ddPPPPdd            ',
      '              #PP#              ',
      '              #pp#              ',
      '               #pp#             ',
      '                #pp#            ',
      '                 #pp#           ',
      '                  #pp#          ',
      '                   #pPP#        ',
      '                    #PPP#       ',
    ],
    [
      '              ryyr              ',
      '              #yy#              ',
      '            d#PPPP#d            ',
      '            d#yPPy#d            ',
      '             #PPPP#             ',
      '              #PP#              ',
      '             #PPPP#             ',
      '        ##pp#PPPPPP#pp##        ',
      '      ##pPpp#PPPPPP#ppPp##      ',
      '    ##ppPppp#PPPPPP#pppPpp##    ',
      '   #ppPppPpp #PPPP# ppPppPpp#   ',
      '   #pppPpppp #PPPP# ppppPppp#   ',
      '    #pppPppp #PPPP# pppPppp#    ',
      '      ##pppp #PPPP# pppp##      ',
      '        ##ppdpPPPPpdpp##        ',
      '            ddPPPPdd            ',
      '              #PP#              ',
      '              #pp#              ',
      '             #pp#               ',
      '            #pp#                ',
      '           #pp#                 ',
      '          #pp#                  ',
      '        #PPp#                   ',
      '       #PPP#                    ',
    ],
  ],
];
